import fetch from '@/utils/fetch';

export function getCaptcha(data) {
    return fetch({
        url: '/api/captcha',
        method: 'get',
        params: data
    })
}



export function loginUser(data) {
    return fetch({
        url: '/User/login',
        method: 'post',
        data
    })
}


export function download(data,fileName) {
    if(fileName){
        return new Promise(() => {
            fetch({
                url: '/Download/Zip',
                method: 'post',
                responseType:'blob',
                contentType:'application/octet-stream',
                data
            }).then(res => {
                let url = window.URL.createObjectURL(res);
                let a = document.createElement('a');
                a.href = url;
                a.download = `${fileName}.zip`;
                a.click();
                //资源释放
                window.URL.revokeObjectURL(url);
            }).catch(err=>{
                
            })
        })
    }else{
        
    }
}

export function downloadFile(data,fileName) {
    if(fileName){
        return new Promise(() => {
            fetch({
                url: '/Download/File',
                method: 'post',
                responseType:'blob',
                contentType:'application/octet-stream',
                data
            }).then(res => {
                let url = window.URL.createObjectURL(res);
                let a = document.createElement('a');
                a.href = url;
                a.download = `${fileName}`;
                a.click();
                //资源释放
                window.URL.revokeObjectURL(url);
            }).catch(err=>{
                
            })
        })
    }else{
        
    }
}

export function downloadFileById(data,fileName) {
    if(fileName){
        return new Promise(() => {
            fetch({
                url: '/Download/FileById?id='+data,
                method: 'get',
                responseType:'blob',
                contentType:'application/octet-stream',
            })
        })
    }else{
        
    }
}


export function exportExcel(url,fileName) {
    return new Promise(() => {
        fetch({
            url: url,
            method: 'get',
            responseType: 'blob',
            contentType: 'application/octet-stream',
        }).then(res => {
            let url = window.URL.createObjectURL(res);
            let a = document.createElement('a');
            a.href = url;
            a.download = `${fileName}`;
            a.click();
            //资源释放
            window.URL.revokeObjectURL(url);
        }).catch(err => {
            
        })
    })
}
